module.exports = __webpack_public_path__ + "static/media/background2.a6a556d2.webp";